import React from 'react';
import Slider from 'react-slick';
import style from '../../../packs/slick_carousel_style';
import { ArticleCard } from './cards/ArticleCard';

export function DashboardArticles({ headers, recommended_articles }) {
	return (
		<div className="articles-container">
			<div className="row">
				<div className="columns small-12">
					<h3>{headers.articles.fields['en-US'].title}</h3>
				</div>
			</div>
			<div className="row">
				<div className="columns medium-9 small-12">
					{headers.articles.fields['en-US'].subtitle}
				</div>
			</div>
			<div className="row">
				<div className="columns small-12 carousel-container">
					<Slider {...style} className="slick-carousel">
						{recommended_articles.map((articleData, index) => {
							return (
								<ArticleCard
									articleData={articleData}
									key={index}
									heartButtonFunction={() =>
										setArticleData(articleData)
									}
								/>
							);
						})}
					</Slider>
				</div>
			</div>
		</div>
	);
}

export default ArticleCard;
